import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_USERS_CREATE, MANAGE_USERS_EDIT, MANAGE_USERS_LIST, MANAGE_USERS_RESEND_ACTIVATION_MAIL, MANAGE_USERS_UPDATE_ACCOUNT_STATUS, MANAGE_USERS_UPDATE_LOGIN_STATUS, MANAGE_USERS_UPDATE_PERMISSION, MANAGE_USERS_VERIFY_EMAIL, MANAGE_USERS_VIEW, SUBADMIN_AS_COLLABORATOR } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const rolesApi = createApi({
    reducerPath: 'rolesApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/roles-permission",
    }),
    tagTypes: ["Permissions", "Users", "UserDetails"],
    endpoints: (builder) => ({

        // Get Permissions
        getPermissions: builder.query({
            query: (id) => ({
                method: "GET",
                url: `/${id}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Permissions"]
        }),

        // get users
        getUsersWithRole: builder.query({
            query: ({ search = "", role = "", status = "", page = 1, limit = 10, sort = { column: "lastname", direction: "desc" } }) => ({
                method: "PATCH",
                url: MANAGE_USERS_LIST,
                data: { search, role, status, page, limit, sort },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["Users"]
        }),

        // get user details
        getUserDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_USERS_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["UserDetails"]
        }),

        // Create sub admin
        createSubAdmin: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_USERS_CREATE,
                data
            }),
            invalidatesTags: ["Users"]
        }),

        // update sub admin
        updateSubAdmin: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MANAGE_USERS_EDIT}/${id}`,
                data
            }),
            invalidatesTags: ["Users", "UserDetails"]
        }),

        // update sub admin account status
        updateSubAdminAccountStatus: builder.mutation({
            query: ({ userId, status }) => ({
                method: "PUT",
                url: `${MANAGE_USERS_UPDATE_ACCOUNT_STATUS}/${userId}/${status}`
            }),
            invalidatesTags: ["Users"]
        }),

        // update sub admin login status
        updateSubAdminLoginStatus: builder.mutation({
            query: ({ userId, status }) => ({
                method: "PUT",
                url: `${MANAGE_USERS_UPDATE_LOGIN_STATUS}/${userId}/${status}`
            }),
            invalidatesTags: ["Users"]
        }),

        // verify email
        verifySubAdminEmail: builder.mutation({
            query: (userId) => ({
                method: "PUT",
                url: `${MANAGE_USERS_VERIFY_EMAIL}/${userId}`
            }),
            invalidatesTags: ["Users"]
        }),

        // Resend Activation mail
        resendAdminAccountActivationMail: builder.mutation({
            query: (id) => ({
                method: "PUT",
                url: `${MANAGE_USERS_RESEND_ACTIVATION_MAIL}/${id}`
            }),
        }),

        // update permissions
        updateUserPermission: builder.mutation({
            query: ({ moduleId, userId, data }) => ({
                method: "PUT",
                url: `${MANAGE_USERS_UPDATE_PERMISSION}/${moduleId}/${userId}`,
                data
            }),
            invalidatesTags: ["UserDetails"]
        }),

        subAdminAsCollaborator: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${SUBADMIN_AS_COLLABORATOR}/${id}`,
                data
            }),
            invalidatesTags: ["Users", "UserDetails"]
        }),

    }),
})

export const {
    useLazyGetPermissionsQuery,
    useGetUsersWithRoleQuery,
    useGetUserDetailsQuery,
    useCreateSubAdminMutation,
    useResendAdminAccountActivationMailMutation,
    useUpdateUserPermissionMutation,
    useUpdateSubAdminMutation,
    useUpdateSubAdminAccountStatusMutation,
    useUpdateSubAdminLoginStatusMutation,
    useVerifySubAdminEmailMutation,
    useSubAdminAsCollaboratorMutation
} = rolesApi;